module.exports = "../../static/img/cdbestcoach.268bff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpg/cdbestcoach.png
// module id = lsRY
// module chunks = 1